import { CanMatchFn } from '@angular/router';
import { inject } from '@angular/core';
import { PermissionsService } from './permissions.service';
import { SchoolAccountPlan } from '@lib/shared-interface-account';

export function createRequiredPlanGuard(plans: SchoolAccountPlan[]): CanMatchFn {
    return async () => await inject(PermissionsService).hasOneOfPlans(plans);
}
